/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateActivationsControllerFindOneQueryResponse, TemplateActivationsControllerFindOnePathParams, TemplateActivationsControllerFindOneQueryParams, TemplateActivationsControllerFindOne400, TemplateActivationsControllerFindOne401, TemplateActivationsControllerFindOne403, TemplateActivationsControllerFindOne404 } from "../../models/checklistsController/TemplateActivationsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { templateActivationsControllerFindOne } from "../../clients/checklistsService/templateActivationsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const templateActivationsControllerFindOneQueryKey = (id: TemplateActivationsControllerFindOnePathParams["id"], params: TemplateActivationsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/checklist-template-activations/:id',
  params: {
    id: id
  }
}, ...(params ? [params] : [])] as const;
export type TemplateActivationsControllerFindOneQueryKey = ReturnType<typeof templateActivationsControllerFindOneQueryKey>;
export function templateActivationsControllerFindOneQueryOptions(id: TemplateActivationsControllerFindOnePathParams["id"], params?: TemplateActivationsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = templateActivationsControllerFindOneQueryKey(id, params);
  return queryOptions<TemplateActivationsControllerFindOneQueryResponse, ResponseErrorConfig<TemplateActivationsControllerFindOne400 | TemplateActivationsControllerFindOne401 | TemplateActivationsControllerFindOne403 | TemplateActivationsControllerFindOne404>, TemplateActivationsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!id,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return templateActivationsControllerFindOne(id, params, config);
    }
  });
}

/**
 * @summary Get a specific template activation by ID
 * {@link /api/v1/checklist-template-activations/:id}
 */
export function useTemplateActivationsControllerFindOne<TData = TemplateActivationsControllerFindOneQueryResponse, TQueryData = TemplateActivationsControllerFindOneQueryResponse, TQueryKey extends QueryKey = TemplateActivationsControllerFindOneQueryKey>(id: TemplateActivationsControllerFindOnePathParams["id"], params?: TemplateActivationsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<TemplateActivationsControllerFindOneQueryResponse, ResponseErrorConfig<TemplateActivationsControllerFindOne400 | TemplateActivationsControllerFindOne401 | TemplateActivationsControllerFindOne403 | TemplateActivationsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? templateActivationsControllerFindOneQueryKey(id, params);
  const query = useQuery({
    ...templateActivationsControllerFindOneQueryOptions(id, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<TemplateActivationsControllerFindOne400 | TemplateActivationsControllerFindOne401 | TemplateActivationsControllerFindOne403 | TemplateActivationsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}